import { ConstellationOneListing } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

const MLSPublicRemarks = ({ listingData }: { listingData: ConstellationOneListing }) => (
  <Flex marginTop="1rem">
    <Typography variant="body1">{listingData.PublicRemarks ?? ''}</Typography>
  </Flex>
);
export default MLSPublicRemarks;
